
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ManageSidemenuLayout from '@/components/organisms/layout/ManageSidemenuLayout.vue'
import InputTextBase from '@/components/atoms/InputTextBase.vue'
import ButtonOptional from '@/components/molecules/ButtonOptional.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import TitlePanel from '@/components/organisms/TitlePanel.vue'
import DateTimeRangePicker from '@/components/organisms/DateTimeRangePicker.vue'
import HtmlEditor from '@/components/organisms/HtmlEditor.vue'

/**
 * お知らせ編集
 */
@Component({
  components: {
    ManageSidemenuLayout,
    InputTextBase,
    ButtonOptional,
    ButtonSubmit,
    PanelFrame,
    TitlePanel,
    DateTimeRangePicker,
    HtmlEditor,
  },
})
export default class ManageNoticeEdit extends Vue {
  /** 日付ピッカー */
  @Ref()
  public dateTimeRangePicker!: DateTimeRangePicker

  /** 塾管理権限の画面か否か */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** システム管理権限の画面か否か */
  @Prop({ default: false })
  private isAdmin!: boolean

  /** タイトル初期値 */
  @Prop({ default: '' })
  private defaultTitle!: string

  /** 開始日時の初期値(unixミリ秒) */
  @Prop({ default: null })
  private defaultStartTime!: number | null

  /** 終了日時の初期値(unixミリ秒) */
  @Prop({ default: null })
  private defaultEndTime!: number | null

  /** 選択可能日付の最小値 */
  @Prop({ default: null })
  private minDate!: Date | null

  /** 本文HTML初期値 */
  @Prop({ default: '' })
  private defaultMessageHtml!: string

  /** キャンセルボタン押下時の処理 */
  @Prop()
  private eventCancel!: () => void

  /** 保存ボタン押下時の処理 */
  @Prop()
  private eventSubmit!: () => void

  /** 初期処理完了フラグ */
  private isLoaded = false

  /** タイトル */
  public title = ''

  /** 本文HTML */
  public messageHtml = ''

  /**
   * 初期処理
   */
  private mounted(): void {
    this.title = this.defaultTitle
    this.messageHtml = this.defaultMessageHtml
    this.isLoaded = true
  }
}
